import { aes } from 'codekit/crypto';

import { env } from 'config/env';

export function encrypt(data: string) {
	return aes.encrypt(data, env.NEXT_PUBLIC_CRYPTO_APP_SECRET_KEY);
}

export function decrypt(data: string) {
	return aes.decrypt(data, env.NEXT_PUBLIC_CRYPTO_APP_SECRET_KEY);
}
